import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "uv-tile-form-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "uv-input-name-date" }, "Choose a date", -1)
const _hoisted_3 = {
  key: 0,
  class: "uv-enquiry-error-message"
}
const _hoisted_4 = { class: "uv-tile-form-row" }
const _hoisted_5 = {
  key: 0,
  class: "uv-enquiry-error-message"
}
const _hoisted_6 = {
  key: 2,
  class: "uv-tile-form-row"
}
const _hoisted_7 = { class: "uv-enquiry-error-message" }
const _hoisted_8 = ["disabled"]

import { 
		computed, 
		reactive 
	} from 'vue';
	import { useStore } from 'vuex';
	import { 
		ECtas, 
		EEnquiryTypeId, 
		EStockCategoryId 
	} from '@/enums';
	import { 
		ILocation, 
		IEnquiryState, 
		IEnquiryFormField, 
		IEnquiryPost, 
		IEnquiryPostCarSales, 
		IVehicle,
		IStoreState,
		IOption
	} from '@/types';
	import { isEmail, isPhone } from '@/validators'
	import { toTitleCase, sendFbqEvent } from '@/helpers';
	import TextInput from './TextInput.vue';
	import TextareaInput from './TextareaInput.vue';
	import CheckboxInput from './CheckboxInput.vue';
	import DropdownSelect from './DropdownSelect.vue';
	import Datepicker from 'vue3-date-time-picker';
	import 'vue3-date-time-picker/dist/main.css';
	import { VueRecaptcha } from 'vue-recaptcha';
	import { 
		defaultHeaders, 
		enquiryEndpoint, 
		testdriveEndpoint 
	} from '@/config';

	
export default /*#__PURE__*/_defineComponent({
  props: {
    type: null,
    vehicle: null
  },
  emits: ['posted'],
  setup(__props: any, { emit }) {

const props = __props as {
		type: ECtas | null,
		vehicle: IVehicle | null
	}

	

	

	const showPreferredDealer = (window as any).uvDealerId === 30;
	const recaptchaKey = (window as any).captchaSiteKey;
	const labelSubscribe = `
		<span>Subscribe to our eNewsletter</span>
	`;
	const labelAccept = `
		<span>
			I agree with the website
			<a href="/terms" target="_blank">
				Terms of Use
			</a>
			and that my information will be handled by the Dealer and One Toyota in accordance with the Dealer
			<a href="/privacy" target="_blank">
				Privacy Policy
			</a>
		</span>
	`;

	const store = useStore<IStoreState>();
	const showDateTimes = computed(() => props.type == ECtas.testDriveButton);
	const locations = computed((): Array<IOption> => { 
		return store.state.locations.map((o: ILocation) => {
			const r: IOption = {
				text: o.LocationName, 
				value: o.LocationId.toString()
			}
			return r
		});
	});

	let formTitle = computed((): string => {
		let t = '';
		switch (props.type){
			case ECtas.enquireButton:
				t = "Make an Enquiry"
			break;
			case ECtas.requestAVideoButton:
				t = "Learn More";
			break;
			case ECtas.reserveButton:
				t = "Secure this car with a fully refundable holding deposit for 48 hours."
			break;
			case ECtas.testDriveButton:
				t = "Book a Test Drive";
			break;
		}
		return t;
	});
	

	const formDate = computed({
		get(): Date {
			return state.form.date.value ? new Date(state.form.date.value) : new Date();
		},
		set(val: Date): void {
			state.form.date.value = `${val.getFullYear()}/${val.getMonth()+1}/${val.getDate()}`;
		}
	});

	const state = reactive<IEnquiryState>({
		isFormPosting: false,
		buttonText: 'Send',
		error: "",
		form: {
			name: { 
				value: store.state.customer.name, 
				errorMessage: "Please enter your name.", 
				validation: (val: string) => !!val, 
				hasError: false
			},
			email: { 
				value: store.state.customer.email, 
				errorMessage: "Please enter an email address.", 
				validation: (val: string) => {
					return (
						(isEmail(val) || state.form.phone.value) && 
						(isEmail(val) || !state.form.subscribe.value)
					);
				}, 
				hasError: false
			},
			phone: { 
				value: store.state.customer.phone, 
				errorMessage: "Please enter a mobile number or phone number with an area code.", 
				validation: (val: string) => (isEmail(state.form.email.value) && !val) || isPhone(val), 
				hasError: false
			},
			preferredLocation: { 
				value: props.vehicle?.LocationId || store.state.customer.preferredLocation || -1, 
				errorMessage: "Please select a preferred location.", 
				validation: (val: string) => !!val || !showPreferredDealer, 
				hasError: false
			},
			date: { 
				value: store.state.customer.date, 
				errorMessage: "Please enter a date.", 
				validation: (val: string) => !!val || !showDateTimes.value, 
				hasError: false
			}, 
			time: { 
				value: store.state.customer.time, 
				errorMessage: "Please enter a time.", 
				validation: (val: string) => !!val || !showDateTimes.value, 
				hasError: false
			}, 
			subscribe: { 
				value: store.state.customer.subscribe, 
				errorMessage: "" , 
				validation: () => true, 
				hasError: false
			},
			comment: { 
				value: "", 
				errorMessage: "", 
				validation: () => true, 
				hasError: false
			},
			accept: { 
				value: false, 
				errorMessage: "Please accept the terms.", 
				validation: (val: boolean) => val, 
				hasError: false 
			}, 
			recaptcha: { 
				value: "", 
				errorMessage: "Please complete the captcha.", 
				validation: (val: string) => !!val, 
				hasError: false
			}
		}
	});

	const handleRecaptchaExpired = (): void => {
		state.form.recaptcha.value = "";
	};
	const handleRecaptchaVerify = (response: string): void => {
		state.form.recaptcha.hasError = false;
		state.form.recaptcha.value = response;
	};
	const handleChange = (formField: IEnquiryFormField<any>): void => {
		state.error = "";
		formField.hasError = false;
		return;
	}
	const handleSubmit = (e: Event): void => {
		e.preventDefault();
		if (!isFormValid()) return;
		state.isFormPosting = true;
		state.buttonText = 'Sending...';
		postForm();
	};
	const postCarSales = async ():Promise<IEnquiryPostCarSales | null> => {
		const year = store.state.hasPreYearValue ? 
			typeof props.vehicle?.ManuYear == 'number' ? props.vehicle.ManuYear : -1 : 
			props.vehicle?.ManuYear || -1
		;
		const postObject: IEnquiryPostCarSales = {
			DealerId: (window as any).uvDealerId,
			LocationId: props.vehicle?.LocationId || 0,
			LeadType: 'Used',
			ItemType: 'Car',
			RequestType: 'Dealer',
			Status: 'New',
			Environment: {
				SiteOrigin: window.location.origin,
				IPAddress: '12.12.12.12'
			},
			Prospect: {
				FirstName: state.form.name.value,
				Email: state.form.email.value,
				MobilePhone: state.form.phone.value
			},
			Item: {
				StockNumber: props.vehicle?.StockNum || '',
				Make: props.vehicle?.Make || '',
				Model: props.vehicle?.Model || '',
				DetailsUrl: window.location.origin + props.vehicle?.DetailsPageUrl,
				Year: year,
				Price: props.vehicle?.Price || -1,
				RegistrationNumber: props.vehicle?.Rego || '',
				Colour: props.vehicle?.Colour || '',
				Transmission: props.vehicle?.Transmission || '',
				Odometer: props.vehicle?.Kms || -1,
				FuelType: props.vehicle?.FuelType || '',
				EngineDescription: props.vehicle?.Engine || ''
			},
			Comments: state.form.comment.value,
			Tags: [formTitle.value]
		};
		// get real IP address first then post lead to carsales endpoint
		return fetch('https://api.ipify.org?format=json').then(response => {
			return response.json();
		})
		.then(json => {
			postObject.Environment.IPAddress = json.ip;
			return postObject;
		})
		.catch(e => {
			// send default / dummy IP
			console.log(e, postObject);
			return postObject;
		});
	}
	const getPostObject = (carSalesObj: IEnquiryPostCarSales | null) => {
		let enquiryTypeId = EEnquiryTypeId.enquiryUsed; 
		let preferredDate = '';
		let preferredTime = '';
		const stockCategoryId = store.state.enquiryModal.vehicle?.StockCategoryId || -1;
		switch (props.type){
			case ECtas.enquireButton:
				if (stockCategoryId === EStockCategoryId.new){
					enquiryTypeId = EEnquiryTypeId.enquiryNew;
				}
				else if (stockCategoryId === EStockCategoryId.demo){
					enquiryTypeId = EEnquiryTypeId.enquiryDemo;
				}
				else {
					enquiryTypeId = EEnquiryTypeId.enquiryUsed;
				}
			break;
			case ECtas.requestAVideoButton:
				enquiryTypeId = EEnquiryTypeId.requestVideo;
			break;
			case ECtas.testDriveButton:
				preferredDate = state.form.date.value; // yyyy-mm-dd
				preferredTime = state.form.time.value; // free text
				if (stockCategoryId === EStockCategoryId.new){
					enquiryTypeId = EEnquiryTypeId.testDriveNew;
				}
				else if (stockCategoryId === EStockCategoryId.demo){
					enquiryTypeId = EEnquiryTypeId.testDriveDemo;
				}
				else {
					enquiryTypeId = EEnquiryTypeId.testDriveUsed;
				}
			break;
		}
		const postObject: IEnquiryPost = {
			StockCategoryId: stockCategoryId,
			Comments: state.form.comment.value || '', 
			RecaptchaResponse: state.form.recaptcha.value, 
			CustomerEnquiry: {
				DealerId: (window as any).uvDealerId,
				Name: state.form.name.value,
				LocationId: props.vehicle?.LocationId || -1,
				Phone: state.form.phone.value || '',
				Email: state.form.email.value || '',
				Postcode: null,
				SubscribeToEdm: state.form.subscribe.value == "1", 
				EnquiryTypeId: enquiryTypeId, 
			},
			CarSelectedLocationId: state.form.preferredLocation.value || -1,
			Make: props.vehicle?.Make || '',
			Model: props.vehicle?.Model || '',
			Series: props.vehicle?.Grade || '',
			StockNo: props.vehicle?.StockNum || '',
			VINNumber: props.vehicle?.Vin || '',
			ManuYear: props.vehicle?.ManuYear || 0,
			Price: props.vehicle?.Price || 0,
			Body: props.vehicle?.Body || '',
			Colour: props.vehicle?.Colour || '',
			Engine: `${props.vehicle?.Engine}L ${props.vehicle?.Fuel}`,
			Kms: props.vehicle?.Kms || 0,
			Transmission: props.vehicle?.Transmission || '',
			Rego: props.vehicle?.Rego || '',
			CarSales: carSalesObj, 
			PreferredDate: preferredDate, 
			PreferredTime: preferredTime
		};
		!postObject.PreferredDate && delete postObject.PreferredDate;
		!postObject.PreferredTime && delete postObject.PreferredTime;
		return postObject;
	};
	const postForm = async (): Promise<void> => {
		pushDataLayer();
		pushFqb();
		let carSalesObj: IEnquiryPostCarSales | null = await postCarSales();
		const url = props.type == ECtas.testDriveButton ? testdriveEndpoint : enquiryEndpoint;
		const postObj = getPostObject(carSalesObj);
		const r = await fetch(url, {
			method: 'POST',
			body: JSON.stringify(postObj),
			headers: defaultHeaders("")
		}).then(response => {
			if (response.status === 403 || response.status === 400) {
				console.log(response);
				state.error = "There was a problem submitting your enquiry. Please try again later.";
				return;
			}
			emit('posted');
		}).catch(error => {
			console.log(error);
			state.error = error;
		});
		state.isFormPosting = false;
		state.buttonText = 'Send';
	}
	const pushDataLayer = (): void => {
		let formName = '';
		const scid = props.vehicle?.StockCategoryId;
		const formNameSuffix = scid == EStockCategoryId.new ? ' New' : scid == EStockCategoryId.used ? ' Used' : scid == EStockCategoryId.demo ? ' Demo' : '';
		switch (props.type){
			case ECtas.testDriveButton: 
				formName = 'Test Drive Booking';
			break;
			case ECtas.requestAVideoButton:
				formName = 'Request a Video';
			break;
			case ECtas.enquireButton:
				formName = 'Individual Vehicle Enquiry';
			break;
		}
		let dataLayer = (window as any).dataLayer || [];
		const useEnquiryUsedObj = props.type == ECtas.enquireButton && scid == EStockCategoryId.used;
		let pushObject = useEnquiryUsedObj ? { // as per TAUT-971
			formName: 'Used Vehicle Enquiry',
			vehicleType: 'Used',
			formStatus: 'submitted',
			event: 'toyotaFormSubmitted'
		} : {
			formName: formName + formNameSuffix,
			formStatus: 'submitted',
			vehicleType: 'Used',
			vehicleFranchise: toTitleCase(props.vehicle?.Make || ''),
			vehicleModel: toTitleCase(props.vehicle?.Model || ''),
			vehicleGrade: toTitleCase(props.vehicle?.Grade || ''),
			vehicleDesc: `${props.vehicle?.Year || ''} ${props.vehicle?.Make || ''} ${props.vehicle?.Model || ''} ${props.vehicle?.Grade || ''} ${props.vehicle?.Body || ''} ${props.vehicle?.Transmission || ''}`,
			vehicleGradeVariation: props.vehicle?.Body || '',
			pageType: formName + formNameSuffix + ' Page',
			vin: props.vehicle?.Vin || '',
			event: 'toyotaFormSubmitted'
		};
		console.log('pushDataLayer',pushObject);
		dataLayer.push(pushObject);
	};
	const pushFqb = (): void => {
		let lead_type = '';
		switch (props.type){
			case ECtas.testDriveButton: 
				lead_type = 'Test Drive';
			break;
			default:
				lead_type = 'Enquiry';
			break;
		}
		if (props.vehicle && props.vehicle.StockId){
			var vehicleState = props.vehicle.IsToyotaCertifiedBool ? 'CPO' : 'Used';
			sendFbqEvent('track', 'Lead', {
				lead_type: lead_type,
				content_ids: [props.vehicle.StockId],
				make: props.vehicle.Make,
				model: props.vehicle.Model,
				year: props.vehicle.Year,
				state_of_vehicle: vehicleState,
				exterior_color: props.vehicle.Colour,
				transmission: props.vehicle.Transmission,
				body_style: props.vehicle.Body,
				fuel_type: props.vehicle.FuelType,
				price: props.vehicle.Price
			});
		}
	};
	const getErrorMessage = (field: IEnquiryFormField<any>): string => {
		return field.hasError ? field.errorMessage : "";
	}
	const isFormValid = (): boolean => {
		let hasError = false;
		for (const [key, obj] of Object.entries(state.form)){
			const objError = (obj.hasError = !obj.validation(obj.value));
			hasError = hasError || objError;
		}
		return !hasError;
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "uv-enquiry-form",
    onSubmit: handleSubmit
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("h3", null, _toDisplayString(_unref(formTitle)), 1),
      _createVNode(TextInput, {
        modelValue: _unref(state).form.name.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).form.name.value) = $event)),
        name: "name",
        label: "Name",
        error: getErrorMessage(_unref(state).form.name),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (handleChange(_unref(state).form.name)))
      }, null, 8, ["modelValue", "error"]),
      _createVNode(TextInput, {
        modelValue: _unref(state).form.email.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).form.email.value) = $event)),
        name: "email",
        label: "Email",
        error: getErrorMessage(_unref(state).form.email),
        onChange: _cache[3] || (_cache[3] = ($event: any) => (handleChange(_unref(state).form.email)))
      }, null, 8, ["modelValue", "error"]),
      _createVNode(TextInput, {
        modelValue: _unref(state).form.phone.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).form.phone.value) = $event)),
        name: "phone",
        label: "Phone",
        error: getErrorMessage(_unref(state).form.phone),
        onChange: _cache[5] || (_cache[5] = ($event: any) => (handleChange(_unref(state).form.phone)))
      }, null, 8, ["modelValue", "error"]),
      showPreferredDealer
        ? (_openBlock(), _createBlock(DropdownSelect, {
            key: 0,
            modelValue: _unref(state).form.preferredLocation.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(state).form.preferredLocation.value) = $event)),
            name: "preferredLocation",
            label: "Preferred Location",
            options: _unref(locations),
            error: getErrorMessage(_unref(state).form.preferredLocation),
            onChange: _cache[7] || (_cache[7] = ($event: any) => (handleChange(_unref(state).form.preferredLocation)))
          }, null, 8, ["modelValue", "options", "error"]))
        : _createCommentVNode("", true),
      (_unref(showDateTimes))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_unref(Datepicker), {
                modelValue: _unref(formDate),
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(formDate) ? (formDate).value = $event : null)),
                name: "date",
                label: "Choose a day",
                format: "yyyy/MM/dd",
                autoApply: true,
                enableTimePicker: false,
                onChange: _cache[9] || (_cache[9] = ($event: any) => (handleChange(_unref(state).form.date)))
              }, null, 8, ["modelValue"]),
              (_unref(state).form.date.hasError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(state).form.date.errorMessage), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(TextInput, {
              modelValue: _unref(state).form.time.value,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(state).form.time.value) = $event)),
              name: "time",
              label: "Choose a time",
              placeholder: "eg. 12pm",
              error: getErrorMessage(_unref(state).form.time),
              onChange: _cache[11] || (_cache[11] = ($event: any) => (handleChange(_unref(state).form.time)))
            }, null, 8, ["modelValue", "error"])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(CheckboxInput, {
        modelValue: _unref(state).form.subscribe.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(state).form.subscribe.value) = $event)),
        name: "subscribe",
        label: labelSubscribe,
        value: 1,
        checked: false,
        error: getErrorMessage(_unref(state).form.subscribe),
        onChange: _cache[13] || (_cache[13] = ($event: any) => (handleChange(_unref(state).form.subscribe)))
      }, null, 8, ["modelValue", "error"]),
      _createVNode(TextareaInput, {
        modelValue: _unref(state).form.comment.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(state).form.comment.value) = $event)),
        name: "comment",
        label: "Comment",
        value: "",
        error: getErrorMessage(_unref(state).form.comment),
        onChange: _cache[15] || (_cache[15] = ($event: any) => (handleChange(_unref(state).form.comment)))
      }, null, 8, ["modelValue", "error"]),
      _createVNode(CheckboxInput, {
        modelValue: _unref(state).form.accept.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(state).form.accept.value) = $event)),
        name: "accept",
        label: labelAccept,
        value: 1,
        checked: false,
        error: getErrorMessage(_unref(state).form.accept),
        onChange: _cache[17] || (_cache[17] = ($event: any) => (handleChange(_unref(state).form.accept)))
      }, null, 8, ["modelValue", "error"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(VueRecaptcha), {
          modelValue: _unref(state).form.recaptcha.value,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(state).form.recaptcha.value) = $event)),
          sitekey: _unref(recaptchaKey),
          onVerify: handleRecaptchaVerify,
          onExpired: handleRecaptchaExpired
        }, null, 8, ["modelValue", "sitekey"]),
        (_unref(state).form.recaptcha.hasError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(state).form.recaptcha.errorMessage), 1))
          : _createCommentVNode("", true)
      ]),
      (_unref(state).error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(state).error), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "submit",
        class: "button-brand",
        disabled: _unref(state).isFormPosting
      }, _toDisplayString(_unref(state).buttonText), 9, _hoisted_8)
    ])
  ], 32))
}
}

})